'use client'

import type { ReactNode, CSSProperties } from 'react'
import { resolveTheme, resolveFontPair, themeCssVars } from '@/lib/microsite/themes'

type Props = {
  themeId: string | null | undefined
  accentColor?: string | null
  /** Pareja tipográfica elegida por el merchant. Vacío/inválida = la del tema. */
  fontPairId?: string | null
  /** Intensidad del velo del hero (0..100; 50 = la del tema). null = la del tema. */
  heroOverlayLevel?: number | null
  children: ReactNode
}

/**
 * Inyecta los tokens del tema como variables CSS (--ms-*) en un contenedor raíz.
 * Las secciones del microsite leen esas variables, así que cambiar de tema solo
 * cambia el preset. accentColor y fontPairId (del merchant) sobre-escriben
 * --ms-accent y las dos vars de tipografía.
 */
export function MicrositeTheme({ themeId, accentColor, fontPairId, heroOverlayLevel, children }: Props) {
  const theme = resolveTheme(themeId)
  const vars = themeCssVars(theme, accentColor, fontPairId, heroOverlayLevel) as CSSProperties
  // Se carga la fuente de la pareja EFECTIVA, no la del tema: si el merchant
  // eligió otra, la del tema ya no se usa y traerla sería peso muerto.
  const fontHref = resolveFontPair(theme.id, fontPairId).googleFont
  return (
    <>
      {fontHref && (
        // eslint-disable-next-line @next/next/no-page-custom-font
        <link rel="stylesheet" href={fontHref} />
      )}
      <div
        data-ms-theme={theme.id}
        style={{
          ...vars,
          background: 'var(--ms-bg)',
          color: 'var(--ms-text)',
          fontFamily: 'var(--ms-font-body)',
        }}
      >
        {children}
      </div>
    </>
  )
}
